var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stmnt" }, [
    _c(
      "div",
      {
        staticClass: "history_filters",
        class: {
          all_active:
            _vm.useBB &&
            _vm.includeRetailHistory &&
            _vm.selectedState === "Open" &&
            _vm.activeQueryType !== "TGate"
        }
      },
      [
        _vm.includeRetailHistory
          ? _c("div", { staticClass: "head cashouthead" }, [
              _c("div", { staticClass: "inhead cashout" }, [
                _c(
                  "span",
                  {
                    key: "Statement.IncludeRetailHistory",
                    staticClass: "ttl stmnt-infocon"
                  },
                  [_vm._v(_vm._s(_vm.$t("Statement.IncludeRetailHistory")))]
                ),
                _vm._v(" "),
                _c("button", {
                  staticClass: "stmnt-tgl filterbbtgl",
                  class: { on: _vm.filterIsRTHistory },
                  on: {
                    click: function($event) {
                      return _vm.toggleRTFilter()
                    }
                  }
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.useBB
          ? _c("div", { staticClass: "head cashouthead" }, [
              _vm.selectedState === "Open" && _vm.activeQueryType !== "TGate"
                ? _c("div", { staticClass: "inhead cashout" }, [
                    _c(
                      "span",
                      {
                        key: "Statement.BetHistoryTitle4Open",
                        staticClass: "ttl stmnt-infocon"
                      },
                      [_vm._v(_vm._s(_vm.$t("Statement.BetHistoryTitle4Open")))]
                    ),
                    _vm._v(" "),
                    _vm.isLoggedIn
                      ? _c(
                          "button",
                          {
                            staticClass: "stmnt-tgl filterbbtgl",
                            class: { on: _vm.filterIsBuyBackOnly },
                            on: {
                              click: function($event) {
                                return _vm.toggleBuybackFilter()
                              }
                            }
                          },
                          [_vm._v("BB only")]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _vm.selectedState === "NonOpen" || _vm.selectedState === "All"
      ? _c("div", { staticClass: "head datepickerhead" }, [
          _c(
            "div",
            {
              staticClass: "inhead bordered clickable",
              class: {
                calendar_active:
                  _vm.filterVisiblePicker == "from" ||
                  _vm.filterVisiblePicker == "to"
              },
              on: {
                click: function() {
                  if (_vm.brandTemplate !== "generic_2") {
                    _vm.togglePickers()
                  }
                }
              }
            },
            [
              _vm.brandTemplate !== "generic_2"
                ? [
                    _c("div", [
                      _c("span", { staticClass: "minittl" }, [
                        _vm._v(_vm._s(_vm.$t("Statement.daterange")))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "ttl filtertgl" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.historyDateRange.from,
                              _vm.dateFormats.longDate
                            )
                          ) +
                            " - " +
                            _vm._s(
                              _vm._f("moment")(
                                _vm.historyDateRange.to,
                                _vm.dateFormats.longDate
                              )
                            )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("v-icon", [_vm._v("calendar_today")])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.brandTemplate === "generic_2" &&
              (_vm.selectedState === "NonOpen" || _vm.selectedState === "All")
                ? _c("div", { staticClass: "fdr-heading" }, [
                    _c(
                      "button",
                      {
                        staticClass: "stmnt-btn datebtn",
                        class: { active: _vm.filterVisiblePicker === "from" },
                        on: {
                          click: function($event) {
                            return _vm.selectPickerGenericTemplate("from")
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "headhint" }, [
                          _vm._v(_vm._s(_vm.$t("Statement.daterange.from")))
                        ]),
                        _vm._v(" "),
                        _vm.filterDateRange.from
                          ? _c("span", { staticClass: "date" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterDateRange.from,
                                    _vm.dateFormats.longDate
                                  )
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.filterDateRange.from
                          ? _c("span", { staticClass: "date" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.historyDateRange.from,
                                    _vm.dateFormats.longDate
                                  )
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "icon_calendar" })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "stmnt-btn datebtn",
                        class: { active: _vm.filterVisiblePicker === "to" },
                        on: {
                          click: function($event) {
                            return _vm.selectPickerGenericTemplate("to")
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "headhint" }, [
                          _vm._v(_vm._s(_vm.$t("Statement.daterange.to")))
                        ]),
                        _vm._v(" "),
                        _vm.filterDateRange.to
                          ? _c("span", { staticClass: "date" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterDateRange.to,
                                    _vm.dateFormats.longDate
                                  )
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.filterDateRange.to
                          ? _c("span", { staticClass: "date" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.historyDateRange.to,
                                    _vm.dateFormats.longDate
                                  )
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "icon_calendar" })
                      ]
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    false
      ? _c("div", [
          _vm._v("\n      selectedState: " + _vm._s(_vm.selectedState)),
          _c("br"),
          _vm._v("\n      useBB: " + _vm._s(_vm.useBB)),
          _c("br"),
          _vm._v(
            "\n      bb.msg: " +
              _vm._s(_vm.bb.msg) +
              " | " +
              _vm._s(_vm.bb.msgtype)
          ),
          _c("br"),
          _vm._v(
            "\n      bb.bet.SB: " +
              _vm._s(_vm.bb && _vm.bb.bet && !!_vm.bb.bet.SB)
          ),
          _c("br"),
          _vm._v(" "),
          _vm._v("\n      bbStatus: " + _vm._s(_vm.bbStatus)),
          _c("br"),
          _vm._v("\n      bbStatus.state: " + _vm._s(_vm.bbStatus.state)),
          _c("br"),
          _vm._v(" "),
          _vm._v(
            "\n      filterDateRange: " +
              _vm._s(_vm.filterDateRange.from) +
              " - " +
              _vm._s(_vm.filterDateRange.to) +
              "]"
          ),
          _c("br"),
          _vm._v("\n      historyStatus: " + _vm._s(_vm.historyStatus)),
          _c("br"),
          _vm._v(
            "\n      filterIsBuyBackOnly: " + _vm._s(_vm.filterIsBuyBackOnly)
          ),
          _c("br")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c("div", { staticClass: "stmnt-block note" }, [
          _vm._v(_vm._s(_vm.$t("Statement.LoginToSeeBetHistory")))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoggedIn &&
    (_vm.filterVisiblePicker == "from" || _vm.filterVisiblePicker == "to")
      ? _c("div", { staticClass: "stmnt-fdaterang" }, [
          _c(
            "div",
            { staticClass: "fdr-wrap" },
            [
              _vm.brandTemplate !== "generic_2"
                ? _c("div", { staticClass: "fdr-heading" }, [
                    _c("div", { staticClass: "stmnt-btnset x2 fullw" }, [
                      _c("div", { staticClass: "sbtnwrap" }, [
                        _c(
                          "button",
                          {
                            staticClass: "stmnt-btn datebtn",
                            class: {
                              active: _vm.filterVisiblePicker === "from"
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectPicker("from")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "headhint" }, [
                              _vm._v(_vm._s(_vm.$t("Statement.daterange.from")))
                            ]),
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  _vm.filterDateRange.from,
                                  _vm.dateFormats.longDateWitDayName
                                )
                              )
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "sbtnwrap" }, [
                        _c(
                          "button",
                          {
                            staticClass: "stmnt-btn datebtn",
                            class: { active: _vm.filterVisiblePicker === "to" },
                            on: {
                              click: function($event) {
                                return _vm.selectPicker("to")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "headhint" }, [
                              _vm._v(_vm._s(_vm.$t("Statement.daterange.to")))
                            ]),
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  _vm.filterDateRange.to,
                                  _vm.dateFormats.longDateWitDayName
                                )
                              )
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.filterDateRange.from && _vm.filterVisiblePicker === "from"
                ? _c("v-date-picker", {
                    attrs: {
                      "show-current": _vm.filterDateRange.to,
                      "full-width": true,
                      "no-title": true,
                      max: _vm.filterDateRange.to,
                      "event-color": _vm.calcPickerRangeDate,
                      events: _vm.calcPickerRangeDate,
                      locale: _vm.currentLocale
                    },
                    model: {
                      value: _vm.filterDateRange.from,
                      callback: function($$v) {
                        _vm.$set(_vm.filterDateRange, "from", $$v)
                      },
                      expression: "filterDateRange.from"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.filterDateRange.from && _vm.filterVisiblePicker === "to"
                ? _c("v-date-picker", {
                    attrs: {
                      "show-current": _vm.filterDateRange.from,
                      "full-width": true,
                      "no-title": true,
                      min: _vm.filterDateRange.from,
                      max: _vm._f("moment")(
                        new Date(),
                        _vm.dateFormats.isoDate
                      ),
                      "event-color": _vm.calcPickerRangeDate,
                      events: _vm.calcPickerRangeDate,
                      locale: _vm.currentLocale
                    },
                    model: {
                      value: _vm.filterDateRange.to,
                      callback: function($$v) {
                        _vm.$set(_vm.filterDateRange, "to", $$v)
                      },
                      expression: "filterDateRange.to"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "fdr-footer" }, [
                _c("div", { staticClass: "stmnt-btnset x2 fullw" }, [
                  _vm.brandTemplate !== "generic_2"
                    ? _c("div", { staticClass: "sbtnwrap" }, [
                        _c(
                          "button",
                          {
                            staticClass: "stmnt-btn sb-white",
                            on: {
                              click: function($event) {
                                return _vm.selectPicker("none")
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("Statement.dialog.Close")))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "sbtnwrap" }, [
                    _c(
                      "button",
                      {
                        staticClass: "stmnt-btn sb-blue",
                        on: {
                          click: function($event) {
                            return _vm.applyPickers("from")
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("Statement.dialog.Apply")))
                        ])
                      ]
                    )
                  ])
                ])
              ])
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoggedIn &&
    _vm.bb &&
    _vm.bb.bet &&
    _vm.bb.bet.SB &&
    (!_vm.bbStatus || _vm.bbStatus.state !== "quoting")
      ? _c("div", { staticClass: "stmnt-bbquote" }, [
          _c("div", { staticClass: "bbq-wrap" }, [
            _c("div", { staticClass: "block bbq-heading" }, [
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("Statement.CashOutConfirmation")))
              ]),
              _c(
                "span",
                {
                  staticClass: "bbq-btn bbq-btn-close",
                  on: {
                    click: function($event) {
                      return _vm.cancelBuyBack()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ]),
            _vm._v(" "),
            _vm.bb.quote.Amount && _vm.bb.bet.Quote !== _vm.bb.quote.Amount
              ? _c("div", { staticClass: "block bbq-info" }, [
                  _c("div", { staticClass: "bbq-infomsg bbreoffer" }, [
                    _vm._v(
                      _vm._s(_vm.$t("Statement.CashoutReofferNotification"))
                    )
                  ])
                ])
              : _c("div", { staticClass: "block bbq-info" }, [
                  _c(
                    "div",
                    { staticClass: "bbq-infomsg stmnt-infocon icblue" },
                    [_vm._v(_vm._s(_vm.$t("Statement.CashOutInfo")))]
                  )
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "block bethead" }, [
              _c("div", { staticClass: "betoverview" }, [
                _vm.bb.bet.SB && _vm.isSingle(_vm.bb.bet.SB)
                  ? _c("div", { staticClass: "betttl" }, [
                      _vm._v(_vm._s(_vm.bb.bet.SB.Legs[0].Event))
                    ])
                  : _vm.bb.bet.SB && _vm.bb.bet.SB.BetTypeExt
                  ? _c("div", { staticClass: "betttl" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(_vm.bb.bet.SB.BetTypeExt, {
                              betType: _vm.bb.bet.SB.BetType,
                              spread: _vm.bb.bet.SB.BetTypeSpread,
                              legs: _vm.bb.bet.SB.numOfNonVoidLegs,
                              tl: _vm.bb.bet.SB.TeaserLevel
                            })
                          )
                        )
                      ]),
                      _vm._v(" "),
                      false && _vm.bb.bet.SB && _vm.bb.bet.SB.BetTypeSpread
                        ? _c("span", { staticClass: "spreadhint" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.bb.bet.SB.BetTypeSpread) +
                                " " +
                                _vm._s(_vm.$t("Statement.spreadHint"))
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm.bb.bet.SB &&
                    _vm.bb.bet.SB.Units &&
                    _vm.bb.bet.SB.Units > 1
                  ? _c("div", { staticClass: "betttl" }, [
                      _vm._v(_vm._s(_vm.bb.bet.SB.BetType) + " "),
                      _vm.bb.bet.SB
                        ? _c("span", { staticClass: "unitshint" }, [
                            _vm._v(
                              "x" +
                                _vm._s(_vm.bb.bet.SB.Units) +
                                " " +
                                _vm._s(_vm.$t("Statement.unitsHint"))
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm.bb.bet.SB
                  ? _c("div", { staticClass: "betttl" }, [
                      _vm._v(_vm._s(_vm.bb.bet.SB.BetType))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bb.bet.Status === "Open"
                  ? _c(
                      "div",
                      { staticClass: "betrefs" },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm._f("moment")(
                                _vm._f("date")(
                                  _vm.bb.bet.Created,
                                  "yyyy-MM-ddThh:mm:ss"
                                ),
                                _vm.dateFormats.longDateTime
                              )
                            ) +
                            "\n              "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _vm.brandLayout !== "generic"
                          ? [
                              _vm._v(
                                "#" +
                                  _vm._s(_vm.bb.bet.InvoiceSlip) +
                                  " - " +
                                  _vm._s(_vm.bb.bet.SB.IDFOBetSlip)
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brandLayout === "generic"
                          ? [
                              _vm._v(
                                _vm._s(_vm.$t("Statement.SlipId")) +
                                  " " +
                                  _vm._s(_vm.bb.bet.SB.IDFOBetSlip)
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "block betbbquotes" }, [
              _c("div", { staticClass: "betbbquote" }, [
                _vm._v(_vm._s(_vm.$t("Statement.CachoutValue"))),
                _c(
                  "span",
                  {
                    staticClass: "money",
                    class: {
                      "blink blink-orange":
                        _vm.bb.bet.Quote !== _vm.bb.quote.Amount
                    }
                  },
                  [_vm._v(_vm._s(_vm._f("currency")(_vm.bb.quote.Amount)))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "betbbquote" }, [
                _vm._v(_vm._s(_vm.$t("Statement.PotentialReturns")) + " "),
                _vm.bb.bet.SB.Potential && _vm.bb.bet.SB.Potential > 0
                  ? _c("span", { staticClass: "money" }, [
                      _vm._v(
                        _vm._s(_vm._f("currency")(_vm.bb.bet.SB.Potential))
                      )
                    ])
                  : _c("span", { staticClass: "money" }, [_vm._v("-")])
              ])
            ]),
            _vm._v(" "),
            !_vm.isGeolocated && _vm.isLoggedIn
              ? _c("div", { staticClass: "block" }, [
                  _c("div", { staticClass: "bbq-infomsg notgeolocated" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("BetSlip.notLocated." + _vm.state)))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("BetSlip.tryAgain." + _vm.state)))
                    ])
                  ])
                ])
              : _vm.bb.quote.Amount
              ? _c("div", { staticClass: "block buyback" }, [
                  _c(
                    "button",
                    {
                      staticClass: "stmnt-btn sb-blue",
                      on: {
                        click: function($event) {
                          return _vm.settleBuyBack(
                            _vm.bb.bet.SB.IDFOBet,
                            _vm.bb.bet
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Statement.CashOutConfirmCashout")))]
                  ),
                  _vm._v(" "),
                  _vm.bbStatus &&
                  (_vm.bbStatus.state === "settling" ||
                    _vm.bbStatus.state === "quoting")
                    ? _c(
                        "div",
                        { staticClass: "bb-loading" },
                        [_c("circle-loader")],
                        1
                      )
                    : _vm._e()
                ])
              : _c("div", [
                  _vm.bb.msg
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "bbq-infomsg msg notgeolocated center-text"
                        },
                        [
                          _c("v-icon", [_vm._v("info_outline")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "msg stmnt-infocon",
                              class:
                                " msg-" +
                                _vm.bb.msgtype +
                                " stmnt-infocon-" +
                                _vm.bb.msgtype
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Statement.CashOut.msg." + _vm.bb.msg)
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.filterVisiblePicker == "none" &&
    !(_vm.historyStatus && _vm.historyStatus.fetching === true) &&
    (!_vm.isLoggedIn || !_vm.history || _vm.history.length < 1)
      ? _c("div", { staticClass: "stmnt-notif" }, [
          _vm.history &&
          _vm.history.length === 0 &&
          _vm.selectedState === "Open"
            ? _c("div", { staticClass: "stmnt-block note" }, [
                _c("span", { staticClass: "main" }, [
                  _vm._v(_vm._s(_vm.$t("Statement.NoOpenRecordsToShow")))
                ])
              ])
            : _vm.history &&
              _vm.history.length === 0 &&
              _vm.selectedState === "NonOpen"
            ? _c("div", { staticClass: "stmnt-block note" }, [
                _c("span", { staticClass: "main" }, [
                  _vm._v(_vm._s(_vm.$t("Statement.NoSettledRecordsToShow")))
                ])
              ])
            : _vm.history &&
              _vm.history.length === 0 &&
              _vm.selectedState === "All"
            ? _c("div", { staticClass: "stmnt-block note" }, [
                _c("span", { staticClass: "main" }, [
                  _vm._v(_vm._s(_vm.$t("Statement.NoRecordsToShow")))
                ])
              ])
            : _vm.history && _vm.history.length === 0
            ? _c("div", { staticClass: "stmnt-ctrls" }, [
                _c(
                  "button",
                  {
                    staticClass: "v-btn sb-blue",
                    on: {
                      click: function($event) {
                        return _vm.gotoLiveBetting()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "v-btn__content" }, [
                      _vm._v(_vm._s(_vm.$t("Statement.GoToLiveBetting")))
                    ])
                  ]
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoggedIn && _vm.filterVisiblePicker == "none"
      ? _c(
          "div",
          { staticClass: "stmnt-bets" },
          [
            _vm._l(_vm.history, function(bet) {
              return _c(
                "div",
                {
                  staticClass: "stmnt-bet",
                  class: [
                    "betstatus-" +
                      bet.statusInner +
                      (bet.SB &&
                      bet.SB.IDFOBet === _vm.bb.idfobet &&
                      _vm.bb.msgtype === "nok"
                        ? " error-outline"
                        : ""),
                    _vm.isFixedPriceTypeBet(bet)
                  ],
                  attrs: {
                    set: [
                      (_vm.isBetSGPV = _vm.isBetSGP(bet)),
                      (_vm.isBetSGPPlusV = _vm.isBetSGPPlus(bet))
                    ]
                  }
                },
                [
                  _c("div", { staticClass: "block bethead mainbethed" }, [
                    bet.SB
                      ? _c(
                          "div",
                          {
                            staticClass: "betoverview",
                            class: { single: bet.SB && _vm.isSingle(bet.SB) }
                          },
                          [
                            bet.Channel && bet.Channel === "RT"
                              ? _c("div", { staticClass: "retail_bet" })
                              : _vm._e(),
                            _vm._v(" "),
                            bet.SB && _vm.isSingle(bet.SB)
                              ? _c(
                                  "div",
                                  { staticClass: "betttl whitetitle Single" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("BetSlip.tab.title.Single")
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : bet.SB && _vm.isBetSGPV
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "betttl whitetitle SameGameParlay"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "BetSlip.tab.title.SGP." +
                                              _vm.isBetSGPV,
                                            { legs: bet.SB.Legs.length }
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              : bet.SB && _vm.isBetSGPPlusV
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "betttl whitetitle SameGameParlayPlus"
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("BetSlip.tab.title.SGP.Plus", {
                                            legs: bet.SB.Legs.length
                                          })
                                        )
                                      }
                                    })
                                  ]
                                )
                              : bet.SB && bet.SB.BetTypeExt
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "betttl whitetitle SB-BetTypeExt Parlay"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(bet.SB.BetTypeExt, {
                                            betType: bet.SB.BetType,
                                            spread: bet.SB.BetTypeSpread,
                                            legs: bet.SB.numOfNonVoidLegs,
                                            tl: bet.SB.TeaserLevel
                                          })
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : bet.SB && bet.SB.Units && bet.SB.Units > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "betttl whitetitle SB-Units MultiBet"
                                  },
                                  [
                                    _vm._v(_vm._s(bet.SB.BetType) + " "),
                                    bet.SB
                                      ? _c(
                                          "span",
                                          { staticClass: "unitshint" },
                                          [
                                            _vm._v(
                                              "x" +
                                                _vm._s(bet.SB.Units) +
                                                " " +
                                                _vm._s(
                                                  _vm.$t("Statement.unitsHint")
                                                )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : bet.SB
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "betttl whitetitle SB-BetType BetType"
                                  },
                                  [_vm._v(_vm._s(bet.SB.BetType))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "betrefs_align" }, [
                              _c(
                                "div",
                                { staticClass: "betrefs" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("moment")(
                                        _vm._f("date")(
                                          bet.Created,
                                          "yyyy-MM-ddThh:mm:ss"
                                        ),
                                        _vm.dateFormats.longDateTime
                                      )
                                    ) + "\n                "
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm.brandLayout !== "generic"
                                    ? [
                                        _vm._v(
                                          "#" +
                                            _vm._s(bet.InvoiceSlip) +
                                            " - " +
                                            _vm._s(bet.SB.IDFOBetSlip)
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.brandLayout === "generic"
                                    ? [
                                        _vm._v(
                                          _vm._s(_vm.$t("Statement.SlipId")) +
                                            " " +
                                            _vm._s(bet.SB.IDFOBetSlip)
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ])
                          ]
                        )
                      : bet.TG
                      ? _c("div", { staticClass: "betoverview" }, [
                          bet.Channel && bet.Channel === "RT"
                            ? _c("div", { staticClass: "retail_bet" })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "betttl whitetitle" }, [
                            _vm._v(
                              _vm._s(_vm.pmTranslatePoolType(bet.TG.PoolType))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "betrefs_align" }, [
                            _c("div", { staticClass: "betrefs" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm._f("date")(
                                      bet.Created,
                                      "yyyy-MM-ddThh:mm:ss"
                                    ),
                                    _vm.dateFormats.longDateTime
                                  )
                                )
                              ),
                              _c("br"),
                              _vm._v(
                                "#" +
                                  _vm._s(bet.InvoiceSlip) +
                                  " - " +
                                  _vm._s(bet.TG.BetId)
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.isBetSGPV
                    ? _c("div", { staticClass: "block bethead sgp-event" }, [
                        _c("div", { staticClass: "sgpeventname" }, [
                          _vm._v(_vm._s(bet.SB.Legs[0].Event))
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isBetSGPPlusV
                    ? _c("div", { staticClass: "block sgp-plus-event" }, [
                        _c("div", { staticClass: "sgpplusparticipants" }, [
                          _vm._v(_vm._s(_vm.sgpPlusParticipants(bet)))
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  bet.SB
                    ? _vm._l(bet.SB.Legs, function(leg) {
                        return _c(
                          "div",
                          {
                            staticClass: "block leg",
                            class:
                              "legstatus-" +
                              (leg.Status ? leg.Status.toLowerCase() : "xx")
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "betsporticon" },
                              [
                                _c("icon", {
                                  attrs: {
                                    name:
                                      "icon-" +
                                      (leg.IDFOSportType.split(" ")
                                        .join("")
                                        .toLowerCase() || "empty")
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "leginfo",
                                class: {
                                  "leginfo-live":
                                    bet.SB &&
                                    bet.SB.BetState == "O" &&
                                    _vm.liveEvents.filter(function(ev) {
                                      return ev.idfoevent == leg.IDFOEvent
                                    }).length > 0
                                }
                              },
                              [
                                _c("div", { staticClass: "leginfo-top" }, [
                                  !_vm.isBetSGPV
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            bet.SB && _vm.isSingle(bet.SB)
                                              ? bet.SB.Legs[0].Event
                                              : leg.Event
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  leg.IDFOSportType === "BASEBALL" &&
                                  leg.PitcherHA &&
                                  (leg.PitcherAway || leg.PitcherHome)
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "PitcherNames",
                                          staticStyle: { "padding-left": "6px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                 " +
                                              _vm._s(
                                                " (" +
                                                  (leg.PitcherAway ||
                                                    "Away Pitcher") +
                                                  " @ " +
                                                  (leg.PitcherHome ||
                                                    "Home Pitcher") +
                                                  ")"
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "leginfo-main" }, [
                                  _c("span", { staticClass: "leginfo-stats" }, [
                                    leg.PriceUp &&
                                    leg.PriceDown &&
                                    !_vm.sgpPriceTypes.includes(
                                      leg.IDFOPriceType &&
                                        (leg.IDFOPriceType.toUpperCase() || "")
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "leginfo-odds",
                                            class:
                                              "PriceType-" + leg.IDFOPriceType
                                          },
                                          [_vm._v(_vm._s(_vm.formatOdds(leg)))]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _vm.showLegStatus &&
                                  (bet.SB.BetState !== "O" ||
                                    !_vm.isSingle(bet.SB) ||
                                    leg.Status.toLowerCase() !== "open")
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "leginfo-status",
                                          class:
                                            "legstatus-" +
                                            (leg.Status
                                              ? leg.Status.toLowerCase()
                                              : "xx")
                                        },
                                        [_vm._v(_vm._s(leg.StatusText))]
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(leg.SelectionExt) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "leginfo-sub" }, [
                                  leg.IDFOSportType === "BASEBALL" &&
                                  leg.PitcherHA
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              leg.ParentName || leg.Market
                                            ) +
                                            "\n                  "
                                        ),
                                        leg.ParentName
                                          ? _c("span", [
                                              _vm._v(
                                                " - " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.selection.listedPitcher.option." +
                                                        leg.PitcherHA,
                                                      {
                                                        marketName: leg.Market,
                                                        homePitcher:
                                                          leg.PitcherHome ||
                                                          "Home Pitcher",
                                                        awayPitcher:
                                                          leg.PitcherAway ||
                                                          "Away Pitcher",
                                                        homeTeam:
                                                          leg.TeamHome ||
                                                          "Home Team",
                                                        awayTeam:
                                                          leg.TeamAway ||
                                                          "Away Team"
                                                      }
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !leg.ParentName && leg.Big3 == "ML"
                                          ? _c("span", [
                                              _vm._v(
                                                " - " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.selection.listedPitcher.option.AP"
                                                    )
                                                  )
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    : _c("span", [_vm._v(_vm._s(leg.Market))])
                                ]),
                                _vm._v(" "),
                                _vm.showExternalDescriptionForFlashBettingMarkets &&
                                leg &&
                                leg.ExternalDescription &&
                                leg.ExternalDescription !== leg.Market
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "leginfo-external-description"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(leg.ExternalDescription)
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showEventTsInBetHistory
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "leginfo-main tsstart_info"
                                      },
                                      [
                                        _c("ts-start", {
                                          attrs: { tsstart: leg.Offtime }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                bet.SB &&
                                bet.SB.BetState == "O" &&
                                _vm.liveEvents.filter(function(ev) {
                                  return ev.idfoevent == leg.IDFOEvent
                                }).length > 0
                                  ? _c("div", { staticClass: "legliveicon" }, [
                                      _vm._v(" LIVE")
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      })
                    : bet.TG && bet.TG.Legs && bet.TG.Legs.length > 0
                    ? [
                        _c(
                          "div",
                          { staticClass: "block leg", class: "legstatus-xx" },
                          [
                            _c(
                              "div",
                              { staticClass: "betsporticon" },
                              [
                                _c("icon", {
                                  attrs: { name: "icon-horseracing" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "leginfo" },
                              [
                                _c("div", { staticClass: "leginfo-top" }, [
                                  _vm._v(_vm._s(bet.TG.MeetingName) + " "),
                                  bet.TG.Legs && bet.TG.Legs.length > 0
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            position: "absolute",
                                            right: "0",
                                            top: "0"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.pmFormatStartTs(
                                                bet.TG.Legs[0].RaceStart
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _vm._l(bet.TG.Legs, function(leg, legIx) {
                                  return [
                                    legIx === 0 ||
                                    bet.TG.Legs[legIx].RaceId !==
                                      bet.TG.Legs[legIx - 1].RaceId
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "leginfo-top leggroup-title"
                                          },
                                          [
                                            _vm._v(
                                              "Race " + _vm._s(leg.RaceNumber)
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.racecastPoolTypes.indexOf(
                                      bet.TG.PoolTypeId
                                    ) > -1
                                      ? [
                                          bet.TG.BetType === "STRAIGHT" &&
                                          (legIx === 0 ||
                                            bet.TG.Legs[legIx].LegOrder !==
                                              bet.TG.Legs[legIx - 1].LegOrder)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "leggroup-subtitle"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(leg.LegOrder) +
                                                      " place:"
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (bet.TG.BetType === "PERMUTATION" ||
                                            bet.TG.BetType === "NO_OPTION") &&
                                          legIx === 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "leggroup-subtitle"
                                                },
                                                [_vm._v("In any order:")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          bet.TG.BetType === "BANKER" &&
                                          legIx === 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "leggroup-subtitle"
                                                },
                                                [_vm._v("1st Place:")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          bet.TG.BetType ===
                                            "FLOATING_BANKER" && legIx === 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "leggroup-subtitle"
                                                },
                                                [_vm._v("Key:")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (bet.TG.BetType === "BANKER" ||
                                            bet.TG.BetType ===
                                              "FLOATING_BANKER") &&
                                          legIx > 0 &&
                                          bet.TG.Legs[legIx].LegOrder !==
                                            bet.TG.Legs[legIx - 1].LegOrder
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "leggroup-subtitle"
                                                },
                                                [_vm._v("With:")]
                                              )
                                            : _vm._e()
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "leginfo-main leggroup-entry"
                                      },
                                      [
                                        _vm._v(
                                          "#" +
                                            _vm._s(leg.EntryNumber) +
                                            " " +
                                            _vm._s(
                                              leg.FlagCoupled === true
                                                ? leg.CoupledNames
                                                : leg.RunnerName
                                            )
                                        )
                                      ]
                                    )
                                  ]
                                })
                              ],
                              2
                            )
                          ]
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  bet.SB
                    ? _c("div", { staticClass: "block result" }, [
                        _c(
                          "div",
                          {
                            staticClass: "betodds",
                            class: { hidden: false && bet.SB && !bet.SB.Odds }
                          },
                          [
                            _c("span", { staticClass: "hint" }, [
                              _vm._v(_vm._s(_vm.$t("BetSlip.oddsprice")))
                            ]),
                            _vm._v(" "),
                            bet.SB && bet.SB.Odds && bet.SB.Odds !== 0
                              ? _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.formatOdds(bet.SB)))
                                ])
                              : _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.$t("Statement.Odds.NA")))
                                ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "betstake" }, [
                          _c("span", { staticClass: "hint" }, [
                            _vm._v(_vm._s(_vm.$t("Statement.wager")))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "value" }, [
                            bet.SB.Stake
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm._f("currency")(bet.SB.Stake))
                                  )
                                ])
                              : _c("span", [_vm._v("-")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "betreturn", class: bet.Status },
                          [
                            _c("div", { staticClass: "content-wrapper" }, [
                              bet.Status === "Open" &&
                              bet.SB &&
                              bet.SB.Potential &&
                              bet.SB.Potential > 0
                                ? _c("span", { staticClass: "hint" }, [
                                    _vm._v(_vm._s(_vm.$t("Statement.MaxWin")))
                                  ])
                                : bet.statusInner === "boughtback"
                                ? _c("span", { staticClass: "hint" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("Statement.CASHEDOUT"))
                                    )
                                  ])
                                : _c("span", { staticClass: "hint" }, [
                                    _vm._v(
                                      _vm._s(
                                        bet.StatusText === "Won"
                                          ? _vm.$t("Statement.TotalPayout")
                                          : bet.StatusText
                                      )
                                    )
                                  ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                bet.Status === "Open" &&
                                bet.SB &&
                                bet.SB.Potential &&
                                bet.SB.Potential > 0 &&
                                bet.SB.Stake
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.roundToPrecision(
                                              bet.SB.Potential - bet.SB.Stake
                                            )
                                          )
                                        )
                                      )
                                    ])
                                  : bet.Status === "Open"
                                  ? _c("span", [_vm._v("-")])
                                  : bet.Status === "Lost"
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm._f("currency")(0)))
                                    ])
                                  : bet.Status !== "Open" &&
                                    bet.SB.Return != null
                                  ? _c("span", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.roundToPrecision(
                                                bet.SB.Return
                                              )
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _c("span", [_vm._v("-")])
                              ]),
                              _vm._v(" "),
                              bet.StatusText === "Won" ||
                              bet.statusInner === "boughtback"
                                ? _c("div", { staticClass: "icon_won" })
                                : _vm._e()
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  bet.TG
                    ? _c("div", { staticClass: "block result" }, [
                        _c("div", { staticClass: "betodds" }, [
                          _c("span", { staticClass: "hint" }, [
                            _vm._v(_vm._s(_vm.$t("Statement.Bets")))
                          ]),
                          _vm._v(" "),
                          bet.TG.AmountStake
                            ? _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(bet.TG.AmountStake / bet.TG.AmountUnit)
                                )
                              ])
                            : _c("div", { staticClass: "value" }, [_vm._v(" ")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "betstake" }, [
                          _c("span", { staticClass: "hint" }, [
                            _vm._v(_vm._s(_vm.$t("Statement.wager")))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "value" }, [
                            bet.TG.AmountStake
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(bet.TG.AmountStake)
                                    )
                                  )
                                ])
                              : _c("span", [_vm._v("-")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "betreturn", class: bet.Status },
                          [
                            _c("div", { staticClass: "content-wrapper" }, [
                              _c("span", { staticClass: "hint" }, [
                                _vm._v(_vm._s(bet.StatusText))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                bet.Status === "Open"
                                  ? _c("span", [_vm._v("-")])
                                  : bet.Status === "Lost"
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm._f("currency")(0)))
                                    ])
                                  : bet.Status !== "Open" &&
                                    bet.TG.AmountReturn != null
                                  ? _c("span", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("currency")(
                                              bet.TG.AmountReturn
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _c("span", [_vm._v("-")])
                              ]),
                              _vm._v(" "),
                              bet.StatusText === "Won"
                                ? _c("div", { staticClass: "icon_won" })
                                : _vm._e()
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  bet.SB
                    ? [
                        bet.Bonus
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "betsuffixinfoblock betsuffixinfoblock-voucher"
                              },
                              [
                                _c("div", { staticClass: "block Voucher" }, [
                                  _c("div", { staticClass: "discount" }, [
                                    _c("span", { staticClass: "hint" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("Statement.discount")) +
                                          ":"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "value" }, [
                                      bet.Bonus
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("currency")(bet.Bonus)
                                              )
                                            )
                                          ])
                                        : _c("span", [_vm._v("-")])
                                    ]),
                                    _vm._v(" "),
                                    bet.BonusText
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "voucher-description"
                                          },
                                          [_vm._v(_vm._s(bet.BonusText))]
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !bet.Bonus && bet.BonusText
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "betsuffixinfoblock betsuffixinfoblock-voucher"
                              },
                              [
                                _c("div", { staticClass: "block Voucher" }, [
                                  _c(
                                    "div",
                                    { staticClass: "discount promotion" },
                                    [
                                      _c("span", { staticClass: "hint" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Statement.promotion")
                                          ) + ":"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "voucher-description no-braces"
                                        },
                                        [_vm._v(_vm._s(bet.BonusText))]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        bet.SB.Offers
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "betsuffixinfoblock betsuffixinfoblock-specialoffer from-sb-offers"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "block Voucher SpecialOffer" },
                                  _vm._l(bet.SB.Offers, function(offer) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "discount",
                                        class: offer.Type
                                      },
                                      [
                                        _c("span", { staticClass: "hint" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SpecialOffer." +
                                                  offer.Type +
                                                  ".offer.title"
                                              )
                                            ) + ":"
                                          )
                                        ]),
                                        _vm._v(" "),
                                        offer.Return
                                          ? _c(
                                              "span",
                                              { staticClass: "value" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      offer.Return
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _c("span", [_vm._v("-")]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "voucher-description"
                                          },
                                          [
                                            _vm._v(
                                              "(" + _vm._s(offer.Name) + ")"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        bet.Status === "Open" &&
                        !bet.SB.Offers &&
                        bet.SB.ExtraData
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "betsuffixinfoblock betsuffixinfoblock-specialoffer from-ExtraData",
                                attrs: {
                                  set: [
                                    (_vm.sOffers = _vm.processSOextraData(
                                      bet.SB
                                    ))
                                  ]
                                }
                              },
                              [
                                _vm.sOffers && _vm.sOffers.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "block Voucher SpecialOffer so-eligible"
                                      },
                                      _vm._l(_vm.sOffers, function(offer) {
                                        return (offer.Id ===
                                          "PARLAYINSURANCE" &&
                                          offer.Return === 0) ||
                                          offer.Id === "PARLAYBOOST"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "discount",
                                                class: offer.Id
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "hint" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "SpecialOffer." +
                                                            (offer.id ||
                                                              offer.Id) +
                                                            ".offer.title.Open"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                (offer.Amount &&
                                                  offer.Return) ||
                                                offer.Id === "PARLAYBOOST"
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "value" },
                                                      [
                                                        _vm._v(
                                                          ": " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "currency"
                                                              )(offer.Return)
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                offer.Id !==
                                                  "PARLAYINSURANCE" ||
                                                _vm.showSOInsuranceNameOnReceipt
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "voucher-description"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(offer.Name) +
                                                            ")"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        bet.Status === "Open" &&
                        bet.SB &&
                        bet.Quote &&
                        bet.Quote > 0 &&
                        (!bet.Channel ||
                          bet.Channel === "W3" || bet.Channel === "MB")
                          ? _c("div", { staticClass: "block buyback" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "stmnt-btn stmnt-btn-buyback",
                                  on: {
                                    click: function($event) {
                                      return _vm.quoteBuyBack(bet.SB.IDFOBet)
                                    }
                                  }
                                },
                                [
                                  _c("icon", {
                                    attrs: {
                                      name: "icon-available-for-bb-white"
                                    }
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("Statement.CashOut")) +
                                      " " +
                                      _vm._s(_vm._f("currency")(bet.Quote)) +
                                      "\n            "
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.bb &&
                              _vm.bb.bet &&
                              _vm.bb.bet.SB &&
                              _vm.bb.bet.SB.IDFOBet === bet.SB.IDFOBet
                                ? _c(
                                    "div",
                                    { staticClass: "bb-loading" },
                                    [_c("circle-loader")],
                                    1
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        bet.Status === "Open" &&
                        bet.SB &&
                        bet.Quote &&
                        bet.Quote > 0 &&
                        bet.Channel &&
                          bet.Channel !== "W3" &&
                          bet.Channel !== "MB"
                          ? _c("div", { staticClass: "block buyback" }, [
                              _c(
                                "button",
                                { staticClass: "stmnt-btn stmnt-btn-buyback" },
                                [
                                  _c("icon", {
                                    attrs: {
                                      name: "icon-available-for-bb-white"
                                    }
                                  }),
                                  _vm._v(
                                    "\n             " +
                                      _vm._s(_vm._f("currency")(bet.Quote)) +
                                      " - " +
                                      _vm._s(
                                        _vm.$t(
                                          "Statement.CashOut.NotAvailableOnline"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              )
            }),
            _vm._v(" "),
            _vm.historyStatus &&
            _vm.historyStatus.error &&
            _vm.historyStatus.error === "SessionTimeout"
              ? _c("div", { staticClass: "stmnt-block note" }, [
                  _vm._v(_vm._s(_vm.$t("Statement.SessionTimeout")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.historyStatus && _vm.historyStatus.fetching === true
              ? _c(
                  "div",
                  { staticClass: "stmnt-block loading" },
                  [_c("circle-loader")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (!_vm.historyStatus || _vm.historyStatus.fetching === false) &&
            _vm.history &&
            _vm.history.length &&
            _vm.pageNumber + 1 < _vm.pageCount &&
            _vm.pageCount > 0
              ? _c("div", { staticClass: "stmnt-ctrls" }, [
                  _vm.pageNumber + 1 < _vm.pageCount && _vm.pageCount > 0
                    ? _c(
                        "button",
                        {
                          staticClass: "v-btn",
                          on: {
                            click: function($event) {
                              return _vm.loadMore()
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "v-btn__content" }, [
                            _vm._v(_vm._s(_vm.$t("Statement.LoadMoreDown")))
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.history && _vm.history.length
              ? _c("div", { staticClass: "note note-pagehint" }, [
                  _vm._v(
                    "showing pages 1-" +
                      _vm._s(_vm.pageNumber + 1) +
                      " of " +
                      _vm._s(_vm.pageCount)
                  )
                ])
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6813858d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6813858d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Statement.vue
// module id = null
// module chunks = 